import { T } from "services/lang/LanguageService";
import { ReportOptions } from "models/component-print-models";
import {
  DashboardComponentPropsBase,
} from "components/pages/dashboard/components/interfaces";
import { Instant } from "@js-joda/core";
import { DatasetLoadingConf } from "../charts/interfaces";
import { IComponentTheme } from "../product-template-table/utils/interfaces";

export interface ValueChangeIndicatorProps extends DashboardComponentPropsBase<ReportOptions>, IComponentTheme {
  datasets: string[];
  title: string;
  subtitle: string;
  dataDisplayType: DataDisplayType;
  aggregationPeriod?: AggregationPeriod;
  displayLastValueDiff: boolean;
  diffType: DiffType;
  updateFrequency?: number;
  diffValueDecimalPlaces?: number;
  useDiffIndicatorColors?: boolean;
  highlightValue?: boolean;
  loadConf: DatasetLoadingConf;
  displayInline?: boolean;
  width?: number;
  hideUnit?: boolean;
  decimalPlaces?: number;
  upToUnit?: AggregationPeriod;
  useDataUpToLastFinishedMonth?: boolean;
  useDataUpToLastFinishedWeek?: boolean;
  convertToAbsoluteValues?: boolean;
  hideZeroValues?: boolean;
  hideIfValueIsZeroOrMore?: boolean;
  startOfTheProject?: Instant;
  useStartOfTheProject?: boolean;
}

export enum AggregationPeriod {
  MINUTES = "MINUTES",
  HOURS = "HOURS",
  DAYS = "DAYS",
  WEEKS = "WEEKS",
  MONTHS = "MONTHS",
  YEARS = "YEARS",
}

export const aggregationPeriodOptions = [
  { label: T("time.minutes"), value: AggregationPeriod.MINUTES },
  { label: T("time.hours"), value: AggregationPeriod.HOURS },
  { label: T("time.days"), value: AggregationPeriod.DAYS },
  { label: T("time.weeks"), value: AggregationPeriod.WEEKS },
  { label: T("time.months"), value: AggregationPeriod.MONTHS },
  { label: T("time.years"), value: AggregationPeriod.YEARS },
];

export enum DataDisplayType {
  LAST_VALUE = "Last Value",
  WEEK_YEAR_COMPARISON = "Week-Year Comparison",
  MONTH_YEAR_COMPARISON = "Month-Year Comparison",
  AVERAGE_VALUE = "Average Value",
  HORIZONTAL_BAR_CHART = "Horizontal Bar Chart",
}

export const dataDisplayTypeOptions = [
  { label: T("label.last-value"), value: DataDisplayType.LAST_VALUE },
  { label: T("label.average-value"), value: DataDisplayType.AVERAGE_VALUE },
  { label: T("label.horizontal-bar-chart"), value: DataDisplayType.HORIZONTAL_BAR_CHART },
  { label: T("label.week-year-comparison"), value: DataDisplayType.WEEK_YEAR_COMPARISON },
  { label: T("label.month-year-comparison"), value: DataDisplayType.MONTH_YEAR_COMPARISON },
];

export enum DiffType {
  ABSOLUTE = "absolute",
  PERCENTAGE = "percentage",
}

export const diffTypeOptions = [
  { label: T("word.absolute"), value: DiffType.ABSOLUTE },
  { label: T("word.percentage"), value: DiffType.PERCENTAGE },
];

export interface DiffValueOptions {
  value?: number;
  currentValueInfo: React.ReactNode;
  previousValueInfo: React.ReactNode;
  isHorizontalBarChartDiffLoaded?: boolean;
}
